import axios from 'axios';

export default {
  fetchVisualScheduleOptions({ commit }) {
    axios.get('/api/v2/visual-schedules/options').then((response) => {
      const { templates, displays, subtasks } = response.data;
      commit('setSubCounters', subtasks);
      commit('setTemplates', templates);
      commit('setDisplays', displays);
    });
  },

  setNewVisualSchedule({ commit }, vs) {
    commit('setVisualSchedule', vs);
  },

  setVisualSchedule({ commit }, vsId) {
    axios.get(`/api/v2/visual-schedules/${vsId}`).then((response) => {
      commit('setVisualSchedule', response.data);
    });
  },

  toggleVisualScheduleSharing({ dispatch, getters }, { streamerId }) {
    if (getters.isVisualScheduleSharing) {
      dispatch('stopVisualScheduleSharing');
    } else {
      dispatch('startVisualScheduleSharing', { streamerId });
    }
  },

  startVisualScheduleSharing({ state, commit }, { streamerId }) {
    commit('setVisualScheduleSharing', { id: state.visualSchedule.id, streamerId });
  },

  stopVisualScheduleSharing({ state, commit, dispatch, getters }) {
    if (getters.isDemoMode) {
      // In a mock session, multiple participants can share visual schedules one after the other.
      // Due to this, we need to set `staticContent` to `null` after each share session.
      dispatch('setNewVisualSchedule', { ...state.visualSchedule, staticContent: null });
    }
    commit('setVisualScheduleSharing', {});
  },

  updateCardPositions({ state, commit }) {
    state.visualSchedule.visual_schedule_cards_attributes.forEach((card, i) => {
      card.position = i + 1;
    });
    commit('updateVisualSchedule', {
      field: 'visual_schedule_cards_attributes',
      value: state.visualSchedule.visual_schedule_cards_attributes,
    });
    commit('updateVisualScheduleContent', true);
  },
};
